// формирует значения с app.scss
export default {
    colors: {
        general: 'var(--general-color)',
        viber: 'var(--viber-color)',
        telegram: 'var(--telegram-color)',
        whatsapp: 'var(--whatsapp-color)',
        block: 'var(--block-color)',
        wayForPay: 'var(--wayforpay-color)',
        monoPay: 'var(--monopay-color)',
    },
    opacityColors: {
        general: 'var(--general-opacity-color)',
        viber: 'var(--viber-opacity-color)',
        telegram: 'var(--telegram-opacity-color)',
        whatsapp: 'var(--whatsapp-opacity-color)',
    }
}
